/**
 * example message:
 * {
	"messageType": "alertNotification",
	"notificationId": 1645473921270,
	"notificationDetails": {"updateType":"SETUP_FILTERED","notificationType":"TRADE_PLAN_UPDATE","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "TACTIC_TRIGGERED",
	"statusDetails": {"pluginTemplate":{"failedTimeFrames":[{"candleDuration":1,"timeUnit":"MINUTES","open":100.2}]},"triggerPrice":0.0,"tradeDirection":null,"tacticName":"FTFC_FILTER","symbol":"xyz"},
	"date": "2022-02-21T15:05:21.905-0500",
	"timestamp": "1645473921909"
}

 * @param {*} pluginTemplate 
 * @returns object with fields:
 * 1) failedTimeFrames (array of objects containing fields 1) candleDuration, timeUnit, open)
 */
export function ftfcFilterParser(pluginTemplate) {
    const parsedObject = {
        failedTimeFrames: null, //array of objects containing fields 1) candleDuration, timeUnit, open
    }
    if(pluginTemplate) {
        parsedObject.failedTimeFrames=pluginTemplate.failedTimeFrames;
    }
    return parsedObject;
}